<script setup lang="ts">
  import { Label } from "@/components/ui/label";
  import type { FormFieldProps } from "./types";

  const props = withDefaults(defineProps<FormFieldProps>(), {
    readonly: false,
  });
</script>

<template>
  <div class="grid gap-2">
    <Label
      v-if="!props.readonly"
      :for="props.id"
      class="text-sm">
      {{ props.label }}
    </Label>
    <Label
      v-else
      class="text-sm">
      {{ props.label }}
    </Label>
    <template v-if="props.readonly">
      <div class="text-sm text-muted-foreground">
        <slot />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>
